<template>
  <div class="wt2-sg wt-field-compound">
    <linked-fields-tags-browser
      v-if="showLinkedFieldsBrowser"
      :linkedFields="linkedFieldsSchema"
      @cancel="showLinkedFieldsBrowser = false"
      @selected="changeValue"
      :options="linkedFieldsOptions"
    />
    <div
      class="wt2-text-field -media-link -storyboard-text"
      @click="showLinkedFieldsBrowser = true"
      :class="{ '-with-link': !!linkedFieldsOptions.value }"
    >
      <!-- <div class="-storyboard-input-title" v-if="!!value">
        Sample:
        </div> -->
      <span
        :class="['wticon', 'wticon-link2']"
        v-if="!linkedFieldsOptions.value"
      />
      <input
        :placeholder="field.label"
        v-model="linkedFieldsOptions.value"
        tabindex="-1"
      />
      <div
        class="-remove-link"
        title="Remove Media Link"
        @click="reset"
        v-if="!!linkedFieldsOptions.value"
      >
        <i :class="['wticon', 'wticon-close_x']" />
      </div>
    </div>
    <div class="wt-checkbox-toggle">
      <span class="-label-left" v-text="requiredText" />
      <i
        v-if="isReview"
        v-tooltip.extend="tooltip"
        class="wticon wticon-help-alt co-tooltip"
      ></i>
      <wt-toggle v-model="mandatory" @toggle="mandatoryChanged"></wt-toggle>
    </div>
  </div>
</template>

<script>
import fieldsMixin from '../mixins/fields.vue';
import LinkedFieldsTagsBrowser from 'components/linkedFields/LinkedFieldsTagsBrowser.vue';

export default {
  props: {
    field: {
      type: Object,
      required: true,
      validator(value) {
        return _.every(['optionThumbnails', 'defaultValue'], (prop) =>
          _.includes(_.keys(value), prop)
        );
      },
    },
    fieldDataModel: {
      type: Object,
      required: false,
    },
  },

  mixins: [fieldsMixin],
  components: {
    LinkedFieldsTagsBrowser,
  },

  data() {
    return {
      showLinkedFieldsBrowser: false,
      tooltip: {
        title:
          'In case of no reviews, scene will be hidden on auto-generated videos',
        placement: 'right',
        delay: 300,
      },
      value: null,
      linkedFieldsOptions: {
        value: null,
      },
      mandatory: false,
    };
  },

  created() {
    this.value = _.isDefined(this.field.value)
      ? this.field.value
      : this.field.defaultValue;
    if (
      _.isArray(this.fieldDataModel?.linkedFields) &&
      this.fieldDataModel?.linkedFields[0]
    ) {
      this.linkedFieldsOptions.value =
        this.fieldDataModel.linkedFields[0].linkedField;
    }
    this.emitChange({ newValue: this.value, makeDirty: false });
    this.mandatory = this.fieldDataModel?.mandatory || false;

    this.$watch('value', (newValue) => {
      this.emitChange({ newValue });
    });
  },

  mounted() {
    this.fieldReadyNextTick();
  },

  methods: {
    reset(e) {
      this.changeValue({ text: '', value: '' });
      e && e.stopPropagation();
    },
    changeValue(payload) {
      this.showLinkedFieldsBrowser = false;
      this.value = payload ? payload.text : null;
      this.linkedFieldsOptions.value = payload ? payload.value : null;
      this.$emit('storyboardingControlsChanged', {
        name: 'linkedFields',
        value: payload
          ? [
              {
                defaultText: payload.text,
                type: 'linkedField',
                linkedField: payload.value,
              },
            ]
          : null,
      });
    },
    mandatoryChanged(value) {
      this.$emit('storyboardingControlsChanged', { name: 'mandatory', value });
    },
  },

  computed: {
    linkedFieldsSchema() {
      return app.linkedFieldsSchema;
    },
    isReview() {
      return this.field && this.field.fieldClassification === 'Review';
    },
    requiredText() {
      if (this.isReview) {
        return 'Skip scene in case of missing review';
      }

      return 'Field is required';
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
.-storyboard-text {
  margin-bottom: 15px;

  .-storyboard-input-title {
    position: absolute;
    bottom: 10px;
    left: 10px;
    width: 45px;
    display: flex;
    align-items: center;
    pointer-events: none;
    font-weight: 500;
    font-size: 14px;
  }

  input {
    background: transparent;
  }

  &.-media-link {
    cursor: pointer;
    .wticon {
      font-size: 17px;
    }
    input {
      pointer-events: none;
      color: #06a9f4;
      padding: 0 0 0 40px;
      &::placeholder {
        color: #06a9f4;
      }
    }
    .wticon {
      color: #06a9f4;
    }
    &.-with-link {
      input {
        padding-left: 0;
      }
    }
    .-remove-link {
      position: absolute;
      right: 5px;
      top: 10px;
      cursor: pointer;
      z-index: 1;

      i {
        position: relative;
        transform: none;
        left: inherit;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.75);
      }

      &:hover {
        i {
          color: rgba(0, 0, 0, 1);
        }
      }
    }
  }

  &.-scene-title {
    input {
      flex-grow: 1;
      padding-left: 45px;
    }
  }
}
</style>
